const NEWS_ITEM_FETCH_URL = '/ajax/news/fetch/';
const NEWS_ITEM_ID_TOKEN = '<NEWS_ITEM_ID>';
const NEWS_ITEM_DISMISS_URL = `/ajax/news/dismiss/${NEWS_ITEM_ID_TOKEN}/`;
import template from 'lodash/template'


const newsItemDesktopTemplate = template(`
<h1>News</h1>
<div class="news-item" data-news-item-id="<%= id %>">
  <div class="news-content">
    <a class="news_item_dismiss" href='javascript:void 0;'><i class="icon-cancel"></i></a>
    <h2 class="news_item_headline"><%= title %></h2>
    <p class="news_item_content"><%= description %></p>
    <div class="button_holder">
      <a href='<%= link_url %>' class='btn button-primary-inverse small link_button news-button' target='_blank'><%= link_text %></a>
    </div>
  </div>
</div>
`);

const newsItemMobileAndNavTemplate = template(`
<h1>News</h1>
<div class="news-item" data-news-item-id="<%= id %>">
  <div class="news-content">
    <a class="news_item_dismiss" href='javascript:void 0;'><i class="icon-cancel"></i></a>
    <h2 class="news_item_headline"><%= title %></h2>
    <p class="news_item_content"><%= description %></p>
    <div class="button_holder">
      <a href='<%= link_url %>' class='btn button-primary-inverse small link_button news-button' target='_blank'><%= link_text %></a>
    </div>
  </div>
</div>
`);

const templatesByName = {
    news_item_desktop: newsItemDesktopTemplate,
    news_item_mobile: newsItemMobileAndNavTemplate,
    news_item_nav: newsItemMobileAndNavTemplate
};


// Displays the news item, if there is one, in the top part of the notification
// center.
class NewsItemView {

  constructor() {
    this.renderedHtml = null;
    this.containerDiv = null;
    this.dismissUrl = '';
  }

  instantiateIn(notificationsContainerElem) {
    this.containerDiv = notificationsContainerElem.querySelector('.news-item-wrapper');
    this._render();
  }

  setNewsItem(newsItemData) {
    if (! newsItemData) {
      this.renderedHtml = '';
    } else {
      const templateName = this.containerDiv.dataset['templateName'];
      this.renderedHtml = this._newsItemDataToHTML(newsItemData, templateName);
    }
    this._render();
  }

  _newsItemDataToHTML(newsItemData, templateName) {
    const compiledTemplate = templatesByName[templateName];
    if (! compiledTemplate) {
      return '';
    }
    return compiledTemplate(newsItemData);
  }

  _render() {
    if (this.renderedHtml === null || this.containerDiv === null) {
      return;   // not ready to render
    }

    this.containerDiv.innerHTML = this.renderedHtml;
    if (this.renderedHtml) {
      const newsItemId = this.containerDiv.querySelector('div.news-item').dataset['newsItemId'];
      let dismissLink = this.containerDiv.querySelector('.news_item_dismiss');
      this.dismissUrl = NEWS_ITEM_DISMISS_URL.replace(NEWS_ITEM_ID_TOKEN, newsItemId);
      const boundDismissClickedFcn = this._handleDismissedClicked.bind(this);
      evite.when('jquery').then(function () {
        dismissLink.addEventListener('click', boundDismissClickedFcn);
      });
    }
  }

  _handleDismissedClicked(e) {
    e.preventDefault();

    window.evite.fetch(this.dismissUrl, {
      method: 'get',
      credentials: "same-origin"
    });

    // animate the closing - shrink the height and fade to nearly transparent
    // first fix the width and height to the current width/height
    let containerDiv = $(this.containerDiv);
    containerDiv.css({
      width: containerDiv.outerWidth(),
      height: containerDiv.outerHeight()
    });
    containerDiv.animate(
      {
        opacity: 0.25,
        height: "toggle"
      },
      {
        duration: 300,
        complete: function() {
          containerDiv.hide();
        }
      }
    );

    // blank out the html so it doesn't come back in case _render() gets called again
    this.renderedHtml = '';
  }
};


export { NewsItemView };



// WEBPACK FOOTER //
// ./assets/es6/common/news.es6